if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: true
    });

    let quadTabs = document.querySelector('.quad-tabs__tabs');
    if(quadTabs){
        document.querySelectorAll('.quad-tabs').forEach((shortcode) => {
            shortcode.querySelectorAll('.quad-tabs__tabs ul li').forEach((btn) => {
                btn.addEventListener('click', (e) => {
                    shortcode.querySelectorAll('.quad-tabs__tabs ul li').forEach((link) => {
                        if(link.dataset.tag != btn.dataset.tag){
                            link.classList.remove('active');
                        }else{
                            link.classList.add('active');
                        }
                    });
                    shortcode.querySelectorAll('.quad-tabs__item').forEach((item) => {item.classList.remove('active');});
                    shortcode.querySelector(`.quad-tabs__item[data-element="${btn.dataset.tag}"]`).classList.add('active');
                });
            });
        });
        const filter_tab = document.querySelectorAll('.quad-tabs__tabs ul li');filter_tab[0].click();
    }

    let quadFilter = document.querySelector('.filter-quads');
    if(quadFilter){
        $('.filter-quads__filter ul li').click(function(){
            const thisTag = $(this).attr('data-tag');
            $('.filter-quads__slider').slick('unslick');
            $('.filter-quads__filter ul li').removeClass('active');
            $(this).addClass('active');
            $('.filter-quads__item').hide();
            $('.filter-quads__item.'+thisTag).fadeIn();
            $('.filter-quads__item.'+thisTag+' .filter-quads__slider').slick();
        });
        const filter_quad = document.querySelectorAll('.filter-quads__filter ul li');filter_quad[0].click();
    }

    $('.form-module, .text-modules, .global-sitemap').addClass('animate-fade top');
})();